module.exports = __webpack_public_path__ + "static/amazon-or-ebay-featured-b46586d6a6c8bfd719ad6442e3ce95d5.png";